export default __webpack_public_path__ + "static/media/Belt of Dark Malice.6b1accb3.jpg";